<div class="grid">
  <div style="position: absolute; top: 0; left: 0; width: 100%; background-color: rgba(244,244,244,0.8); z-index: -1"></div>
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-sitemap title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.organizations' | transloco}}</p>
            <p>{{'menu.descriptions.organizations' | transloco}}</p>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div>
              <button
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
            </div>
            <div>
              <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                      label=" {{'common.filters' | transloco}}"
                      pButton>
              </button>
            </div>
          </div>
        </div>
        <p-treeTable #treeTable [value]="hierarchy">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.name' | transloco}}</th>
              <th scope="col">{{'attribute.orgCode' | transloco}}</th>
              <th scope="col">{{'attribute.description' | transloco}}</th>
              <th scope="col">{{'attribute.localityState' | transloco}}</th>
              <th scope="col">{{'attribute.organizationType' | transloco}}</th>
              <th scope="col" class="w-10rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr *ngIf="!loadingOrganizations">
              <td>
                <div class="flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <span class="line-height-4">{{rowData.name}}</span>
                </div>
              </td>
              <td>{{rowData.orgCode}}</td>
              <td>{{rowData.description}}</td>
              <td *ngIf="rowData.geocoding">{{rowData.geocoding.locality[language]}}
                ({{rowData.geocoding.state[language]}}, {{rowData.geocoding.country[language]}})
              </td>
              <td *ngIf="!rowData.geocoding"></td>
              <td>{{rowData.organizationType.name}}</td>
              <td>
                <div class="flex justify-content-end">
                  <button *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ALARM_SUBSCRIPTIONS')"
                    [routerLink]="rowData.organizationUuid + '/subscriptions'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-bell"
                  ></button>
                  <button
                    [routerLink]="rowData.organizationUuid + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil" [disabled]="rowData.organizationType.root"
                  ></button>
                  <button
                    (click)="confirmAndDelete(rowData)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    [disabled]="rowData.organizationType.root || nodes[rowData.organizationUuid].children.length > 0"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingOrganizations">
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          appAutoFocus
          pInputText
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="orgCode">{{'attribute.orgCode' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.orgCode"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="orgCode"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="description">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.description"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="description"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="country">{{'attribute.country' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.countries"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body"
          [options]="countries"
          (onChange)="onCountryChange($event)"
          id="country"
          optionLabel="name" optionValue="name"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.states"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body"
          [options]="filteredStates"
          [disabled]="isStateDisabled"
          (onChange)="onStateChange($event)"
          id="state"
          optionLabel="name" optionValue="name"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="locality">{{'attribute.locality' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.localities"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body"
          [options]="filteredLocalities"
          [disabled]="isLocalityDisabled"
          id="locality"
          optionLabel="name" optionValue="name"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organizationType">{{'attribute.organizationType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.organizationTypesUuids"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
          [options]="organizationTypes"
          id="organizationType"
          optionLabel="name"
          optionValue="organizationTypeUuid"
        >
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="parent">{{'attribute.organizationParent' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect
          [(ngModel)]="organizationParent"
          [placeholder]="'select.generic' | transloco"
          [options]="hierarchyFilters"
          (onNodeSelect)="currentFilters.parentUuid=$event.node.data"
          appendTo="body"
          id="parent"
        ></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
            currentFilters.name ||
            currentFilters.orgCode ||
            currentFilters.description ||
            currentFilters.states ||
            currentFilters.localities ||
            currentFilters.organizationTypesUuids ||
            organizationParent
          )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
